const MIDNIGHT_END_TIME = "24:00";

function getLocaleCode(intl) {
  return intl.locale === "en" ? "en-US" : "es-ES";
}

function parseDateOnly(dateStr) {
  if (!dateStr) return null;

  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(year, month - 1, day);
}

function normalizeTimeString(timeStr) {
  return timeStr ? timeStr.substring(0, 5) : "";
}

function isWindowEndingAtMidnight(startTime, endTime) {
  const normalizedEndTime = normalizeTimeString(endTime);

  if (normalizedEndTime === MIDNIGHT_END_TIME) {
    return true;
  }

  return normalizedEndTime === "00:00" && normalizeTimeString(startTime) !== "00:00";
}

function formatWindowTime(timeStr, { treatMidnightAsEndOfDay = false } = {}) {
  const normalizedTime = normalizeTimeString(timeStr);

  if (treatMidnightAsEndOfDay && normalizedTime === "00:00") {
    return MIDNIGHT_END_TIME;
  }

  return normalizedTime;
}

function formatDateLabel(dateStr, intl, options = { day: "numeric", month: "short" }) {
  if (!dateStr) {
    return "-";
  }

  const date = parseDateOnly(dateStr.split(" ")[0]);

  if (!date) {
    return "-";
  }

  return date.toLocaleDateString(getLocaleCode(intl), options);
}

function formatDateRange(startDate, endDate, intl) {
  if (!startDate && !endDate) {
    return intl.formatMessage({ id: "Sin partidos asignados" });
  }

  if (!startDate || !endDate || startDate === endDate) {
    return formatDateLabel(startDate || endDate, intl);
  }

  return `${formatDateLabel(startDate, intl)} -> ${formatDateLabel(endDate, intl)}`;
}

function formatDateInputValue(dateStr) {
  return dateStr ? dateStr.split(" ")[0] : "";
}

function formatDateTimeTime(dateTimeStr) {
  return dateTimeStr ? dateTimeStr.substring(11, 16) : "";
}

function getUnscheduledRoundLabel(unscheduledMatch, intl) {
  if (unscheduledMatch.round_label) {
    return unscheduledMatch.round_label;
  }

  if (unscheduledMatch.is_group_match) {
    if (unscheduledMatch.round) {
      return intl.formatMessage({ id: "Fase de grupos - Ronda {round}" }, { round: unscheduledMatch.round });
    }

    return intl.formatMessage({ id: "Fase de grupos" });
  }

  if (unscheduledMatch.rounds_until_final === 0) {
    return intl.formatMessage({ id: "Final" });
  }

  if (unscheduledMatch.rounds_until_final === 1) {
    return intl.formatMessage({ id: "Semifinal" });
  }

  if (unscheduledMatch.round) {
    return intl.formatMessage({ id: "Ronda {round}" }, { round: unscheduledMatch.round });
  }

  return intl.formatMessage({ id: "Eliminatoria" });
}

function formatDateHeading(dateStr, intl) {
  const date = parseDateOnly(dateStr.split(" ")[0]);
  return date.toLocaleDateString(getLocaleCode(intl), {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
}

export {
  MIDNIGHT_END_TIME,
  formatDateHeading,
  formatDateInputValue,
  formatDateLabel,
  formatDateRange,
  formatDateTimeTime,
  formatWindowTime,
  getLocaleCode,
  getUnscheduledRoundLabel,
  isWindowEndingAtMidnight,
  normalizeTimeString,
  parseDateOnly,
};
